import _ from 'lodash';
import { FormattedMessage } from 'react-intl';

import DocumentsByType from './DocumentsByType/DocumentsByType';
import messages from './UploadedDocuments.messages';

export const UploadedDocuments = ({ uploadedDocuments }) => (
    <>
        <div className="mb-l text-l font-bold">
            <FormattedMessage {...messages.title} />
        </div>
        <div className="mb-m">
            {!_.isEmpty(uploadedDocuments) ? (
                _.map(uploadedDocuments, (doc, documentType) => (
                    <DocumentsByType
                        key={documentType}
                        documentType={documentType}
                        documents={doc}
                    />
                ))
            ) : (
                <FormattedMessage {...messages.noUploadedDocuments} />
            )}
        </div>
    </>
);
